import { GifOverlayProps } from '@giphy/react-components'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { VideoContext } from 'shared/components/context/video-manager'
import GAVideo from '../video-player/sdk-video-with-ga'
import Volume from './volume'

const VideoContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
`

const VideoStyled = styled(GAVideo) <{ isReady: boolean }>`
    height: 100%;
    object-fit: contain;
    background: ${props => (props.isReady ? 'black' : 'transparent')};
`

const VideoOverlay = ({
    gif,
    width,
    height,
    isHovered,
    volumeSize,
    gridPosition,
}: GifOverlayProps & { gridPosition?: number; width: number; height?: number; volumeSize?: number }) => {
    // TODO useLocalStorage here? to save the user's state?
    const [muted, setMuted] = useState<boolean | undefined>(undefined)
    const [mutedByBrowser, setMutedByBrowser] = useState(true)
    const [isReady, setIsReady] = useState(false)
    const { onStartHover, onFinishHover } = useContext(VideoContext)

    const toggleMute = () => {
        if (mutedByBrowser) {
            setMutedByBrowser(false)
            setMuted(false)
        } else {
            setMuted(!muted)
        }
    }

    useEffect(() => {
        if (isHovered) {
            onStartHover?.(gif.id.toString())
        } else {
            setIsReady(false)
            onFinishHover?.(gif.id.toString())
        }
    }, [isHovered])

    if (!isHovered) {
        return <Volume muted isHovered={false} volumeSize={volumeSize} />
    }

    return (
        <VideoContainer>
            <VideoStyled
                gif={gif}
                height={height}
                key={gif.id}
                loop
                muted={muted}
                width={width}
                isReady={isReady}
                onTimeUpdate={time => {
                    if (time > 0) {
                        setIsReady(true)
                    }
                }}
                onMuted={(muted: boolean) => setMutedByBrowser(muted)}
                gridPosition={gridPosition}
            />
            <Volume toggleMute={toggleMute} muted={muted || mutedByBrowser} isHovered={true} volumeSize={volumeSize} />
        </VideoContainer>
    )
}
export default VideoOverlay
